import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { API_CONFIG, AUTH_TOKEN_KEY } from '../../core/config/constants';

const createApiClient = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      console.log('📤 Requête API:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        fullURL: `${config.baseURL}${config.url}`,
        data: config.data
      });
      
      // Liste des endpoints qui ne nécessitent pas d'authentification
      const publicEndpoints = ['/authenticate', '/user/new', '/auth/register'];
      const isPublicEndpoint = publicEndpoints.some(endpoint => config.url?.includes(endpoint));
      
      const token = Cookies.get(AUTH_TOKEN_KEY);
      if (token && config.headers && !isPublicEndpoint) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('🔑 Token ajouté à la requête');
      } else if (isPublicEndpoint) {
        console.log('🔓 Endpoint public - pas de token ajouté');
        // S'assurer qu'aucun header Authorization n'est envoyé
        if (config.headers) {
          delete config.headers.Authorization;
        }
      }
      return config;
    },
    (error) => {
      console.error('❌ Erreur dans l\'intercepteur de requête:', error);
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      console.log('📥 Réponse API reçue:', {
        status: response.status,
        statusText: response.statusText,
        url: response.config.url,
        data: response.data
      });
      return response;
    },
    (error) => {
      console.error('❌ Erreur de réponse API:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: error.config?.url,
        message: error.message,
        data: error.response?.data
      });
      
      if (error.response?.status === 401) {
        console.log('🚪 Redirection vers login (401 Unauthorized)');
        Cookies.remove(AUTH_TOKEN_KEY);
        window.location.href = 'https://vinosk.fr/app';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const apiClient = createApiClient();